import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
export var SIZE_MAP = {
  small: 16,
  default: 28,
  large: 48
};
var UiIndicator = {
  name: 'UiIndicator',
  props: {
    size: {
      type: [Number, String]
    },
    color: {
      type: String
    }
  },
  computed: {
    style: function style() {
      var style = {}; // 处理大小

      var size;

      if (typeof this.size === 'number') {
        size = this.size;
      } else if (typeof this.size === 'string') {
        size = SIZE_MAP[this.size] || SIZE_MAP.default;
      }

      style.fontSize = size + "px"; // 处理颜色

      if (this.color && typeof this.color === 'string') {
        style.color = this.color;
      }

      return style;
    }
  },
  render: function render() {
    var h = arguments[0];
    var list = [1, 2, 3, 4, 5, 6, 7, 8];
    return h("span", {
      "class": 'ui-indicator ui-indicator-flower',
      "style": this.style
    }, [_mapInstanceProperty(list).call(list, function (index) {
      return h("i", {
        "class": 'ui-indicator-flower__line ui-indicator-flower__line--' + index
      });
    })]);
  }
};
export default UiIndicator;